import React, { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '../../config/api';
import ProductCollection from '../UI/ProductCollection';

/** Editor-curated recommendations shown on the landing page. */
const AlsoLike = ({ layout = 'grid', columns, limit }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = useCallback(async (signal) => {
    setLoading(true);
    try {
      const response = await fetch(apiUrl('/api/like-products'), { signal });
      if (!response.ok) throw new Error('Failed to fetch products');
      const data = await response.json();
      setProducts(Array.isArray(data?.liked_products) ? data.liked_products : []);
      setError(null);
    } catch (err) {
      if (err.name !== 'AbortError') setError(err.message);
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchProducts(controller.signal);
    return () => controller.abort();
  }, [fetchProducts]);

  return (
    <ProductCollection
      products={products}
      loading={loading}
      error={error}
      onRetry={() => fetchProducts()}
      layout={layout}
      columns={columns}
      limit={limit}
      skeletonCount={limit || 4}
      emptyTitle="Nothing to recommend just yet"
      emptyMessage="Browse the full collection to find your next favourite piece."
    />
  );
};

export default AlsoLike;
